<template>
  <header class="container whiteBack">
    <div class="row " id="header">
        <div class="col-6 col-xl-5 col-lg-6 col-md-6 imgInline divLogoOrangeHeader">
            <img src="../../assets/images/LogoOrange.jpg" class="img-fluid logoOrange" alt="Orange">
        </div>
        <div class="col-md-6 text-right col-5 imgInline">
            <img class="img-fluid imgLogoDTS" src="../../assets/images/logodigitel.png" alt="digitel">
        </div>
    </div>
</header>
</template>

<script>
export default {
  name:'common-header'
}
</script>



// WEBPACK FOOTER //
// ./src/components/header/header.vue